// @MX:NOTE: SPEC-CHINA-WORKORDER-STEP2-CHINA-INAPI-001 — 이 화면(Step2 고객정보)의 3개 EP
// (getCustomerListByName / getCustomerInfoByMobileAndSendChannel / getAgreements)는 china-inapi(chinaInapi)로 전환 완료.
// 레거시 한국 inapi($apiInstance)를 참조하던 미사용 dead 함수 10종은 SPEC-CHINA-INAPI-RESIDUE-CLEANUP(2026-07-22)에서 제거함
// (호출부 0건 확인). 이제 이 팩토리는 인스턴스 주입 없이 chinaInapi만 사용한다.
import { chinaInapi } from '@/apis/chinaInapi';

export default function issueCertificateCommonApis() {
    return {
        // china-inapi GET /china/customers/by-mobile/v2/:channel/:mobile 로 전환.
        // 신규 EP는 항상 200 + { found:false } 또는 { found:true, name?, mobile?, birth?, gender?, ... } 형태.
        // 호출부(CustomerInfoForm.vue processCustomerInfo)는 레거시 404 예외 기반 신규고객 분기를 그대로 쓰므로,
        // found:false일 때 레거시 404 에러 형태로 합성해서 throw하여 호출부 수정 없이 동일 분기를 태운다.
        // found:true일 때 id/teethNos/agreements는 신규 EP에 없는 필드라 신규고객과 동일한 기본값으로 채운다
        // (Step2.vue 저장 payload가 name/mobile/email/gender/birth/chartNumber만 사용 — id/teethNos/agreements 미사용 확인됨).
        getCustomerInfoByMobileAndSendChannel: async (customerMobile, sendChannel) => {
            try {
                const response = await chinaInapi.get(`/china/customers/by-mobile/v2/${sendChannel}/${customerMobile}`);
                const prefill = response.data;
                if (!prefill.found) {
                    const notFoundError = new Error('customer not found');
                    notFoundError.response = { status: 404 };
                    throw notFoundError;
                }
                return {
                    _id: '',
                    name: prefill.name || '',
                    birth: prefill.birth || null,
                    teethNos: [],
                    gender: prefill.gender || '',
                    agreements: [],
                };
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        // china-inapi POST /china/customers/search 로 전환. body key가 text -> keyword로 변경됨.
        // 응답은 CustomerSearchResultItem[] ({name, mobile, isWechatDeliverable, originSource}) — email 필드는 없으나
        // 호출부(nameDropBoxData)는 email을 optional로 체크하므로 그대로 안전.
        getCustomerListByName: async (textInput) => {
            try {
                const response = await chinaInapi.post('/china/customers/search', { keyword: textInput.text });
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        // china-inapi GET /china/agreements 로 전환 (백엔드 병행 작업으로 신규 추가되는 EP).
        // 응답 shape은 기존과 동일: {_id, name, linkUrl, requiredYn, i18n:[{language,name,linkUrl}], target}[]
        getAgreements: async () => {
            try {
                const response = await chinaInapi.get('/china/agreements');
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
    }
}
